import apiClient from './client';

export const ActivityRuleAxiosInstance = apiClient;